import React from 'react'
import InfoText, { InfoTextProps } from '@e3dc-react/shell/Elements/InfoText/InfoText'
import { styled } from '@mui/material'

/**
 * Styled InfoText component as used all throughout the InstallationDetails Section
 */
export default styled(({ ...props }: InfoTextProps) => <InfoText {...props} titleTop titleVariant="subtitle2" valueVariant="body2" />)({})
